import './components/theme.js';
import './components/choices.js';
import './components/burger.js';
import './components/to-top.js';
import './components/fields.js';
import './components/filter.js';
import './components/slider-price.js';
import './components/swipers.js';
import './components/checkbox.js';
import './components/dropzones.js';
import './components/videos.js';
import './components/modals.js';